export default [{
    name: '小佳',
    avatar: '/call-frontend/小佳.png',
    video: '/call-frontend/小佳.webm',
    standbyRange: [0, 4],
    speekRange: [5.5, 7],
    voiceType: 'AISpeech',
    voiceId: 'gdfanfp'
}, {
    name: '小渝',
    avatar: '/call-frontend/小渝.png',
    video: '/call-frontend/小渝.webm',
    standbyRange: [0, 4],
    speekRange: [5.5, 7],
    voiceType: 'AISpeech',
    voiceId: 'gdfanfp'
}, {
    name: '晓云',
    avatar: '/call-frontend/晓云.png',
    video: '/call-frontend/晓云.webm',
    standbyRange: [0, 4],
    speekRange: [5, 10],
    voiceType: 'AISpeech',
    voiceId: 'gdfanfp'
}, {
    name: '晓云',
    avatar: '/call-frontend/晓云.png',
    video: '/call-frontend/晓云-上半身.webm',
    standbyRange: [0, 4],
    speekRange: [5, 10],
    voiceType: 'AISpeech',
    voiceId: 'gdfanfp'
}];
